module.exports = ['$scope', 'ngMeta', 'bibContentManager', '$notification', 'settings', '$stateParams', function ($scope, ngMeta, bibContentManager, $notification, settings, $stateParams) {
  'use strict';
  $scope.$parent.breadcrumb = null;
  $scope.$parent.title = "Support Zill digitaal";
  ngMeta.setTitle('Support');

  $scope.loading = true;
  $scope.getSections = function (children) {
    if (children) {
      return children.filter(o => o.type === 'SECTION');
    } else {
      return [];
    }
  };

  bibContentManager.getContent(settings.support.faq, ['SECTION', 'PARAGRAPH', 'IMAGE']).then(function(content) {
    var allParts = content;
    $scope.sections = $scope.getSections(allParts.contents);
    $scope.loading = false;
    let category = $scope.sections[0];
    if ($stateParams.key) {
      let searchedSection = $scope.sections.find((section) => section.key === $stateParams.key);
      if(searchedSection) {
        category = searchedSection;
      } else {
        $scope.sections.forEach((section) => {
          let found = section.contents.find((contentSection) => contentSection.key === $stateParams.key);
          if (found) {
            $scope.question = found;
            category = section;
          }
        });
      }
    }
    $scope.setCategory(category);
    $scope.category = category;
  }).catch(function () {
    $notification.error("Probleem bij het laden van deze pagina.");
  });

  $scope.setCategory = function (cat) {
    $scope.category = cat;
  };

  $scope.setQuestion = function (question) {
    $scope.question = question;
  };


}];



// WEBPACK FOOTER //
// ./web/js/screen/support/supportHomeController.js